import { useEffect } from "react";

/** "Final Draft" rename (2026-09) — every client-portal route gets its own tab title,
 * "Final Draft · {Page}" (or plain "Final Draft · NJM Productions" with no page arg). */
export function useDocumentTitle(page) {
  useEffect(() => {
    document.title = page ? `Final Draft · ${page}` : "Final Draft · NJM Productions";
  }, [page]);
}
